import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '~/state/store'

import { ROLES } from '~/constants/roles'

export const isLogged = (state: AppState): boolean => {
  const {
    user: { token }
  } = state

  return !!token
}

export const isAuthorized = (state: AppState): boolean => {
  const {
    user: { confirmed, token }
  } = state

  return !!token && confirmed
}

export const getRole = (state: AppState): RolesUnion => state.user.role

export const isCenter = createSelector(
  getRole,
  (role: RolesUnion) => role === ROLES.image_center
)

export const isClinic = createSelector(
  getRole,
  (role: RolesUnion): boolean => role === ROLES.clinic
)
